import { jsxs as m, jsx as s } from "react/jsx-runtime";
import { c as o } from "../../../index-CvSFHqCB.js";
import * as t from "react";
import { c as a } from "../../../utils-BOFVZgHd.js";
const v = o(
  "w-full rounded-lg bg-[var(--card)] text-[var(--card-foreground)] min-h-[100px]",
  {
    variants: {
      layout: {
        default: "p-2",
        row: "flex flex-row gap-4",
        column: "flex flex-col gap-4"
      },
      variant: {
        default: "bg-[var(--background)] border border-[var(--border)]",
        ghost: "border-none bg-transparent"
      }
    },
    defaultVariants: {
      layout: "default",
      variant: "default"
    }
  }
), b = o("font-medium leading-none tracking-tight text-[var(--foreground)]", {
  variants: {
    size: {
      default: "text-lg",
      sm: "text-base",
      lg: "text-xl"
    }
  },
  defaultVariants: {
    size: "default"
  }
}), N = o("text-[var(--muted-foreground)]", {
  variants: {
    size: {
      default: "text-sm mt-2",
      sm: "text-xs mt-1.5",
      lg: "text-base mt-2.5"
    }
  },
  defaultVariants: {
    size: "default"
  }
}), w = "w-full", V = t.forwardRef(
  ({ className: u, children: r, label: n, description: l, layout: x = "default", variant: i, size: d = "default" }, g) => {
    console.log("Section: ", { variant: i });
    const c = v({ layout: x, variant: i }), f = c.includes("flex-row"), p = () => f ? t.Children.map(
      r,
      (e) => t.isValidElement(e) && typeof e.type == "string" ? t.cloneElement(e, {
        className: a(
          typeof e.props.className == "string" ? e.props.className : void 0,
          "flex-1"
        )
      }) : e
    ) : r;
    return /* @__PURE__ */ m("div", { ref: g, className: a(w, u), children: [
      /* @__PURE__ */ m("div", { className: "flex flex-col gap-4", children: [
        n && /* @__PURE__ */ s("h3", { className: a(b({ size: d }), "mb-2"), children: n }),
        l && /* @__PURE__ */ s("p", { className: a(N({ size: d }), "mb-4"), children: l })
      ] }),
      /* @__PURE__ */ s("div", { className: c, children: f ? p() : r })
    ] });
  }
);
V.displayName = "Section";
export {
  V as Section,
  v as sectionVariants
};
//# sourceMappingURL=index.js.map
